import { render, staticRenderFns } from "./thankYouPage.vue?vue&type=template&id=a125c386&"
import script from "./thankYouPage.vue?vue&type=script&lang=js&"
export * from "./thankYouPage.vue?vue&type=script&lang=js&"
import style0 from "./thankYouPage.vue?vue&type=style&index=0&id=a125c386&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports